/* Mana Mātauranga · Sample 1: product photo gallery, quantity buttons, sticky
   add-to-cart bar and the slide-out cart. The cart always shows Shopify's own
   numbers (prices, EXAM10 discount, totals). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const body = document.body;
  const money = c => '$' + (c / 100).toFixed(2);
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const json = (url, data) => fetch(url, {
    method: data ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: data ? JSON.stringify(data) : undefined,
  }).then(r => r.json());

  /* ---------- gallery + quantity + colour buttons ---------- */
  document.addEventListener('click', e => {
    const sw = e.target.closest('[data-mm-swatch]');
    if (sw) {
      const root = sw.closest('[data-mm-product]') || document;
      $$('[data-mm-swatch]', root).forEach(b => b.setAttribute('aria-pressed', String(b === sw)));
      $$('form input[name="id"]', root).forEach(i => { i.value = sw.dataset.variant; });
      const label = $('[data-mm-swatch-label]', root);
      if (label) label.textContent = sw.dataset.name;
      const thumbs = $$('[data-mm-colour]', root);
      const has = thumbs.some(b => b.dataset.mmColour === sw.dataset.key);
      thumbs.forEach(b => { b.hidden = has && b.dataset.mmColour !== 'all' && b.dataset.mmColour !== sw.dataset.key; });
      const main = $('.mm-pdp__main img', root);
      if (sw.dataset.image && main) {
        main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = sw.dataset.image;
        $$('[data-mm-thumb]', root).forEach(b => b.classList.toggle('is-on', b.dataset.mmThumb === sw.dataset.image));
      }
      const buy = $('.mm-pdp__buy [type="submit"]', root);
      if (buy) { const ok = sw.dataset.available === 'true'; buy.disabled = !ok; buy.textContent = ok ? 'Add to cart' : 'Sold out'; }
      try { history.replaceState(null, '', location.pathname + '?variant=' + sw.dataset.variant + location.hash); } catch (err) { /* fine */ }
      return;
    }
    const th = e.target.closest('[data-mm-thumb]');
    if (th) {
      const g = th.closest('[data-mm-gallery]');
      const main = g && $('.mm-pdp__main img', g);
      if (main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = th.dataset.mmThumb; }
      $$('[data-mm-thumb]', g).forEach(b => b.classList.toggle('is-on', b === th));
      return;
    }
    const q = e.target.closest('[data-mm-q]');
    if (q) {
      const inp = q.parentElement.querySelector('input');
      if (inp) inp.value = Math.max(1, Math.min(99, (parseInt(inp.value, 10) || 1) + parseInt(q.dataset.mmQ, 10)));
    }
  });

  /* ---------- sticky bar ---------- */
  function sticky() {
    $$('[data-mm-sticky]').forEach(bar => {
      const a = $('[data-mm-buy-anchor]', bar.closest('[data-mm-product]'));
      bar.classList.toggle('show', !!a && a.getBoundingClientRect().bottom < 0);
    });
  }
  window.addEventListener('scroll', sticky, { passive: true });

  /* ---------- cart drawer ---------- */
  const drawer = () => $('[data-mm-drawer]');
  const setCount = n => $$('[data-mm-cart-count]').forEach(el => { el.textContent = n; el.classList.toggle('has', n > 0); });
  function msg(html, bad) {
    const m = $('[data-mm-code-msg]');
    if (m) { m.innerHTML = html; m.classList.toggle('is-bad', !!bad); }
  }
  const thumb = url => (url ? url + (url.includes('?') ? '&' : '?') + 'width=160' : '');

  function render(cart) {
    const d = drawer();
    if (!d || !cart || !cart.items) return;
    setCount(cart.item_count);
    const free = Number(d.dataset.free || 10000);
    const items = cart.items;
    $('[data-mm-drawer-items]', d).innerHTML = items.length ? items.map((it, i) => `
      <div class="mm-ci">
        <a class="mm-ci__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(thumb(it.image))}" alt="">` : ''}</a>
        <div>
          <a class="mm-ci__name" href="${esc(it.url)}">${esc(it.product_title)}</a><span class="mm-ci__type">${esc(it.product_type)}</span>
          <div class="mm-qty mm-qty--sm"><button type="button" data-mm-line="${i + 1}" data-mm-to="${it.quantity - 1}" aria-label="One less">−</button><output>${it.quantity}</output><button type="button" data-mm-line="${i + 1}" data-mm-to="${it.quantity + 1}" aria-label="One more">+</button></div>
        </div>
        <div class="mm-ci__right">${it.final_line_price < it.original_line_price ? `<s>${money(it.original_line_price)}</s>` : ''}<span class="mm-ci__price">${money(it.final_line_price)}</span><button type="button" class="mm-ci__rm" data-mm-line="${i + 1}" data-mm-to="0">Remove</button></div>
      </div>`).join('')
      : '<div class="mm-cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="mm-btn mm-btn--primary">Find the right calculator</a></div>';

    const total = cart.total_price;
    const left = Math.max(0, free - total);
    $('[data-mm-ship-msg]', d).innerHTML = !items.length ? `Free NZ shipping on orders over ${money(free).replace('.00', '')}`
      : left > 0 ? `You're <b>${money(left)}</b> away from free shipping` : '<b>Free shipping unlocked</b> ✓';
    $('[data-mm-ship-fill]', d).style.width = Math.min(100, (total / free) * 100) + '%';
    $('[data-mm-sub]', d).textContent = money(cart.original_total_price != null ? cart.original_total_price : cart.items_subtotal_price);
    const codes = (cart.discount_codes || []).filter(c => c.applicable).map(c => c.code);
    $('[data-mm-disc-row]', d).hidden = !cart.total_discount;
    $('[data-mm-disc-label]', d).textContent = codes.length ? `Discount (${codes.join(', ')})` : 'Discount';
    $('[data-mm-disc]', d).textContent = '−' + money(cart.total_discount || 0);
    $('[data-mm-ship]', d).textContent = !items.length ? '—' : left > 0 ? 'At checkout' : 'Free';
    $('[data-mm-total]', d).textContent = money(total);
    $('[data-mm-checkout]', d).setAttribute('aria-disabled', items.length ? 'false' : 'true');
    if (codes.length) msg(codes.map(c => `<b>${esc(c)}</b> applied · <button type="button" data-mm-code-rm="${esc(c)}">Remove</button>`).join(' · '));
    else if (!$('[data-mm-code-msg]', d).classList.contains('is-bad')) msg('');
  }

  async function open() {
    const d = drawer();
    if (!d) return;
    body.classList.add('mm-cart-open');
    d.setAttribute('aria-hidden', 'false');
    render(await json('/cart.js'));
  }
  function close() {
    body.classList.remove('mm-cart-open');
    const d = drawer();
    if (d) d.setAttribute('aria-hidden', 'true');
  }
  async function busy(fn) {
    const d = drawer();
    if (d) d.classList.add('is-busy');
    try { return await fn(); } finally { if (d) d.classList.remove('is-busy'); }
  }

  document.addEventListener('click', async e => {
    if (e.target.closest('[data-mm-open-cart]') && drawer()) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-mm-close-cart]')) { close(); return; }
    const line = e.target.closest('[data-mm-line]');
    if (line) {
      await busy(async () => render(await json('/cart/change.js', { line: +line.dataset.mmLine, quantity: Math.max(0, +line.dataset.mmTo) })));
      return;
    }
    const rm = e.target.closest('[data-mm-code-rm]');
    if (rm) {
      await busy(async () => {
        const cart = await json('/cart.js');
        const keep = (cart.discount_codes || []).filter(c => c.applicable && c.code !== rm.dataset.mmCodeRm).map(c => c.code);
        msg('');
        render(await json('/cart/update.js', { discount: keep.join(',') }));
      });
    }
  });

  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-mm-code-form]');
    if (!f) return;
    e.preventDefault();
    const code = f.code.value.trim().toUpperCase();
    if (!code) { msg('Type a code first.', true); return; }
    await busy(async () => {
      const before = await json('/cart.js');
      const prev = (before.discount_codes || []).filter(c => c.applicable).map(c => c.code).filter(c => c.toUpperCase() !== code);
      let cart = await json('/cart/update.js', { discount: prev.concat(code).join(',') });
      const hit = (cart.discount_codes || []).find(c => c.code.toUpperCase() === code);
      if (!hit || !hit.applicable) {
        cart = await json('/cart/update.js', { discount: prev.join(',') });
        msg(`“${esc(code)}” isn't valid for what's in your cart.`, true);
      } else {
        msg('');
        f.code.value = '';
      }
      render(cart);
    });
  });

  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  // mm-s1.js fires this after a quick add-to-cart: open the drawer instead of the small message
  document.addEventListener('mm:added', e => { if (drawer()) { e.preventDefault(); open(); } });
})();
